import type { RefObject } from 'react';
import { useRef } from 'react';

type CallbackFunction = () => void;

export const useAsyncTriggerCallback = (): [() => Promise<void>, RefObject<CallbackFunction | null>] => {
  const callbackRef = useRef<CallbackFunction | null>(null);

  const triggerAsyncCallback = async (): Promise<void> => {
    await new Promise(resolve => {
      callbackRef.current = resolve as CallbackFunction;
    });

    callbackRef.current = null;
  };

  return [triggerAsyncCallback, callbackRef];
};
